import { useEffect, useState } from "react";

let cache: string[] | null = null;
let inflight: Promise<string[]> | null = null;
async function fetchTerms(): Promise<string[]> {
  if (cache) return cache;
  inflight ??= fetch("/api/v1/subjects/keywords").then(async (r) => {
    cache = r.ok ? ((await r.json()).data ?? []) : [];
    return cache!;
  }).catch(() => (cache = []));
  return inflight;
}
export function useKeywordTerms(): string[] {
  const [t, setT] = useState<string[]>(cache ?? []);
  useEffect(() => { fetchTerms().then(setT); }, []);
  return t;
}
const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function Highlight({ text, extra }: { text: string | null | undefined; extra?: (string | null | undefined)[] }) {
  const base = useKeywordTerms();
  if (!text) return null;
  const terms = [...base, ...(extra ?? [])].filter((x): x is string => !!x && x.trim().length >= 3);
  if (terms.length === 0) return <>{text}</>;
  const re = new RegExp(`(?<![\\p{L}\\p{N}])(${[...new Set(terms)].sort((a, b) => b.length - a.length).map(esc).join("|")})(?![\\p{L}\\p{N}])`, "giu");
  const parts = text.split(re);
  return (
    <>
      {parts.map((p, i) =>
        i % 2 === 1 ? <mark key={i} style={{ background: "#ffe58a", padding: "0 2px", borderRadius: 2 }}>{p}</mark> : <span key={i}>{p}</span>
      )}
    </>
  );
}
